import React from 'react';
import { Tooltip, TooltipContent, TooltipProvider, TooltipTrigger } from '@/components/ui/tooltip';
import { Zap } from 'lucide-react';

export const StpBadge = ({ compact = false }) => (
  <TooltipProvider delayDuration={150}>
    <Tooltip>
      <TooltipTrigger asChild>
        <span data-testid="stp-badge"
          className={`inline-flex items-center gap-1 rounded font-semibold cursor-help ${compact ? 'text-[11px]' : 'px-2 py-0.5 text-[10px]'}`}
          style={compact ? { color: '#00B4D8' } : { background: 'rgba(0,180,216,0.12)', color: '#0E7490' }}>
          {!compact && <Zap className="w-2.5 h-2.5" />}STP
        </span>
      </TooltipTrigger>
      <TooltipContent side="bottom" className="max-w-[280px] text-xs leading-relaxed" data-testid="stp-tooltip">
        <p className="font-semibold mb-1">Straight-Through Processing</p>
        <p>This risk scored inside the auto-issue band, so ARIA rated, priced and issued it end-to-end with no human touch. Referrals, declines and manual re-rates switch STP off.</p>
      </TooltipContent>
    </Tooltip>
  </TooltipProvider>
);
